import { useQuery } from "@tanstack/react-query";
import { GetDispatchBoardQueueRequest } from "app/data/city-delivery/dispatch-board/models";
import CityDeliveryDiaptchBoardService from "app/data/city-delivery/dispatch-board/cityDeliveryDiaptchBoardService";
import { QUERY_KEYS } from "app/data/common/queryKeys";

export const useDispatchBoardQueue = (requestData: GetDispatchBoardQueueRequest) => {
  const {
    data: dispatchBoardQueueData,
    isLoading: isLoadingDispatchBoardQueue,
    refetch: refetchDispatchBoardQueue
  } =
    useQuery({
      queryKey: [QUERY_KEYS.GET_DISPATCH_BOARD_QUEUE, requestData.terminalNumber],
      queryFn: async () => {
        if (requestData && requestData.terminalNumber) {
          const response = await CityDeliveryDiaptchBoardService.getInstance().getDispatchBoardQueue(requestData);
          return response;
        }
      },
      refetchOnWindowFocus: false,
      enabled: true,
      retry: true,
    })
  return {
    dispatchBoardQueueData,
    isLoadingDispatchBoardQueue,
    refetchDispatchBoardQueue
  };
}